export const ADD_SECOND_PAGE = 'add-second-page';
export const ADD_THIRD_PAGE = 'add-third-page';
export const ADD_FOURTH_PAGE = 'add-forth-page';
export const ADD_FIFTH_PAGE = 'add-fifth-page';
